module.exports = __webpack_public_path__ + "assets/img/rank.2f18ea7d.png";